export default __webpack_public_path__ + "static/media/Welcome.e14405c8d058f1f2f3f6a34d8c50865b.webp";